// extracted by mini-css-extract-plugin
export default {"list-tags":"list-tags_list-tags__8p-++","inline":"list-tags_inline__nHiTO","selected":"list-tags_selected__Oiox-"};